import React, { useState } from "react";
import { TvIcon } from "@heroicons/react/24/outline";
import { getFullMediaUrl } from "../../utils/mediaUtils";

interface CampaignThumbProps {
  thumbnailUrl?: string | null;
  /** Only ever an image URL: a video's own file can never load in an <img>. */
  imageUrl?: string | null;
  /** Tailwind size classes, so each caller picks how big the preview is. */
  className?: string;
}

/**
 * A creative's preview image.
 *
 * Three things have to line up or this renders as a broken-image glyph: the
 * backend returns an S3 *key*, not a URL, so it needs getFullMediaUrl; a
 * video's fileUrl is an .mp4 an <img> can never display, so only an image
 * creative may fall back to it; and the key can point at an object that no
 * longer exists, which only onError can catch.
 */
const CampaignThumb: React.FC<CampaignThumbProps> = ({
  thumbnailUrl,
  imageUrl,
  className = "h-10 w-16",
}) => {
  const [failed, setFailed] = useState(false);
  const src = getFullMediaUrl(thumbnailUrl || imageUrl || null);

  if (!src || failed) {
    return (
      <div
        className={`flex flex-shrink-0 items-center justify-center rounded border border-gray-200 bg-gray-50 text-gray-400 ${className}`}
      >
        <TvIcon className="h-4 w-4" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      onError={() => setFailed(true)}
      className={`flex-shrink-0 rounded border border-gray-200 object-cover ${className}`}
    />
  );
};

export default CampaignThumb;
